module.exports = "\n<app-download-control fileName='2018-06-05_15-39-38.png' filePath='Agent/182/duediligence/AGT_W9F/2018-06-29T19:20:03.232Z/2018-06-05_15-39-38.png'></app-download-control>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/download-control-test/download-control-test.component.html
// module id = ./src/app/components/download-control-test/download-control-test.component.html
// module chunks = main